<template>
    <el-drawer title="推荐设置" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close" append-to-body>
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="id" label="挂载绑定:">
                    <el-input placeholder="请输入ID" v-model="query.id">
                        <el-select v-model="query.type" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="0"></el-option>
                            <el-option label="场地ID" :value="1"></el-option>
                            <el-option label="分享活动ID" :value="2"></el-option>
                            <el-option label="膨胀红包ID" :value="3"></el-option>
                            <el-option label="幸运抽奖ID" :value="4"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-search" @click="queryDataHandle()"></el-button>
                    </el-input>
                    <el-table class="MT10" :data="queryDataList" border style="width: 100%" v-loading="listLoading" size="small">
                        <el-table-column prop="type" label="类型">
                        </el-table-column>
                        <el-table-column prop="id" label="ID">
                        </el-table-column>
                        <el-table-column prop="title" label="名称">
                        </el-table-column>
                        <el-table-column label="操作" >
                            <template>
                                <el-button type="text" size="mini" @click="clearQueryData()">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item prop="datetimerange" label="展示时间:">
                    <el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']" unlink-panels>
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    articleId: "",
    startTime: "",
    endTime: "",
    id: "",
    type: 0,
    datetimerange: []
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            listLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                id: [{ required: true, message: "未绑定推荐资源ID" , tigger: 'change' }],
                datetimerange: [{ required: true, message: "请选择时间" }],
            },
            query: {
                id: '',
                type: 0
            },
            queryDataList: []
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData,
                datetimerange: []
            }
            this.queryDataList = [];
            this.query = {
                id: '',
                type: 0
            }
        },
        show(data) {
            const _startTime = data.mountStartTime ? this.$utils.formatDate(data.mountStartTime, 'yyyy-MM-dd HH:mm:ss') : '';
            const _endTime = data.mountEndTime ? this.$utils.formatDate(data.mountEndTime, 'yyyy-MM-dd HH:mm:ss') : '';
            
            this.formData = {
                ...defaultData,
                articleId: data.id,
                startTime: _startTime,
                endTime: _endTime,
                datetimerange: _startTime ? [_startTime, _endTime] : [],
                id: data?.mountId,
                type: data?.mountType || 0,
            }
            if( data?.mountId ){
                this.query = {
                    id: data.mountId,
                    type: data?.mountType,
                }
                this.queryDataHandle();
            }
            this.drawerShow = true;
        },
        queryDataHandle(){
            this.listLoading = true;
            this.$request({
                url: "/article/queryMount",
                method: "POST",
                params: {
                    ...this.query,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.queryDataList =  [result];
                    this.formData.id = result.id;
                    this.formData.type = this.query.type;
                    this.$refs.formData.clearValidate('id');
				} else {
                    this.clearQueryData();
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        clearQueryData(){
            this.queryDataList = [];
            this.formData.id = "";
            this.formData.type = "";
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    let _formData = {
                        ...this.formData,
                        startTime: this.formData.datetimerange && this.formData.datetimerange[0] || '',
                        endTime: this.formData.datetimerange && this.formData.datetimerange[1] || ''
                    }
                    delete _formData.datetimerange;
                    this.$request({
                        url: '/article/createMount',
                        params: {
                            ..._formData
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success("操作成功");
                                setTimeout(() => {
                                    this.$emit('onUpdate');
                                    this.close();
                                }, 1000);
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            })
        }
    }
}
</script>